/** Canonical tier ids: essentials, essayist, laureate */
const PLAN_ALIASES = {
	scholar: 'essentials',
	fellow: 'essayist',
	laurette: 'laureate'
};

export function normalizePlanTier(planName) {
	if (!planName) return planName;
	const raw = String(planName).toLowerCase().trim();
	return PLAN_ALIASES[raw] || raw;
}
